;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MasterCardErrors = require("./MasterCardErrors.vue");

var _MasterCardErrors2 = _interopRequireDefault(_MasterCardErrors);

var _VerifyTransaction = require("./VerifyTransaction.vue");

var _VerifyTransaction2 = _interopRequireDefault(_VerifyTransaction);

var _TransactionSuccessful = require("./TransactionSuccessful.vue");

var _TransactionSuccessful2 = _interopRequireDefault(_TransactionSuccessful);

var _MasterCardIframe = require("./MasterCardIframe.vue");

var _MasterCardIframe2 = _interopRequireDefault(_MasterCardIframe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "MasterCard",
  components: {
    MasterCardErrors: _MasterCardErrors2.default,
    VerifyTransaction: _VerifyTransaction2.default,
    TransactionSuccessful: _TransactionSuccessful2.default,
    MasterCardIframe: _MasterCardIframe2.default
  },
  props: {
    activeGateway: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    formParams: {
      type: Object,
      required: true
    },
    base_url: {
      type: String,
      default: null
    },
    invoice_no: {
      type: String,
      required: true
    },
    walletToken: {
      type: String,
      required: true
    },
    invoice: {
      type: Object,
      required: true
    },
    card_profile_id: {
      type: String,
      required: true
    },
    callback_url: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      showCardErrors: false,
      cardErrors: [],
      loading: true,
      success: false,
      require3DS: false,
      threeDSHtml: null
    };
  },
  mounted: function mounted() {

    this.initiate3DS();
  },

  computed: {
    amountToCharge: function amountToCharge() {
      var amount = void 0;
      amount = parseFloat(this.activeGateway.configs.card_charges) + parseFloat(this.invoice.amount_expected);

      return Math.ceil(amount * 100) / 100;
    }
  },
  methods: {
    initiate3DS: async function initiate3DS() {
      try {
        var mastercard_api_url = this.base_url + this.activeGateway.configs.mpgs_initiate_url;
        var browserDetails = {
          javaEnabled: navigator.javaEnabled ? navigator.javaEnabled() : false,
          language: navigator.language,
          colorDepth: screen.colorDepth,
          screenHeight: screen.height,
          screenWidth: screen.width,
          timeZone: new Date().getTimezoneOffset(),
          acceptHeaders: navigator.acceptLanguages ? navigator.acceptLanguages.join(",") : "application/json",
          userAgent: navigator.userAgent
        };
        var payload = {
          gid: this.activeGateway.id,
          card_profile: this.card_profile_id,
          payment_info: {
            amount: this.amountToCharge,
            currency: this.currency,
            invoice_number: this.invoice_no,
            card_number: this.formParams.card_number.replace(/\s+/g, ""),
            expiry_date: this.formParams.expiry_date,
            cvv: this.formParams.cvv,
            transaction_id: this.formParams.tracking_no,
            browser_details: browserDetails,
            first_name: this.formParams.first_name,
            last_name: this.formParams.last_name
          }
        };
        var mastercard_response = await Vue.axios.post(mastercard_api_url, payload, this.getAuthHeaders());
        var data = mastercard_response.data;

        if (data.status === "paid") {
          this.handlePaymentSuccess(data);
        } else if (data.status === "3ds_required") {
          this.loading = false;
          this.threeDSHtml = data.html;

          this.require3DS = true;
        } else {
          this.handlePaymentError();
        }
      } catch (error) {
        console.error("Error initiating 3DS:", error);
        this.handlePaymentError();
      }
    },
    handlePaymentSuccess: function handlePaymentSuccess(data) {
      this.loading = false;
      this.success = true;
    },
    handlePaymentError: function handlePaymentError() {
      this.loading = false;
      this.cardErrors = [];

      this.$emit("routeMasterCardToCyberSource");
    },
    handleTryAnotherWay: function handleTryAnotherWay() {
      this.$emit("routeMasterCardToCyberSource");
    },
    getAuthHeaders: function getAuthHeaders() {
      return {
        headers: {
          Authorization: "Bearer " + this.walletToken,
          "Content-Type": "application/json"
        }
      };
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('VerifyTransaction'):_vm._e(),_vm._v(" "),(_vm.require3DS)?_c('MasterCardIframe',{attrs:{"html":_vm.threeDSHtml,"invoice":_vm.invoice,"callback_url":_vm.callback_url},on:{"tryAnotherWay":_vm.handleTryAnotherWay}}):_vm._e(),_vm._v(" "),(_vm.success)?_c('TransactionSuccessful'):_vm._e(),_vm._v(" "),(_vm.showCardErrors)?_c('MasterCardErrors',{attrs:{"errors":_vm.cardErrors}}):_vm._e()],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-043f145a", __vue__options__)
  } else {
    hotAPI.reload("data-v-043f145a", __vue__options__)
  }
})()}